import { toUrlSafeForSignedUrl } from "utility/cloudfront";

import type { Cookie } from "@spwn/types/functions";

const createPresignedUrlQueryParameter = (cookie: Cookie["cookie"]): string => {
  const {
    "CloudFront-Key-Pair-Id": keyPairId,
    "CloudFront-Policy": policy,
    "CloudFront-Signature": signature,
  } = cookie;

  const params = [
    `Policy=${toUrlSafeForSignedUrl(policy)}`,
    `Signature=${toUrlSafeForSignedUrl(signature)}`,
    `Key-Pair-Id=${keyPairId}`,
  ].join("&");

  return params;
};

export const generateSignedM3u8Url = (
  manifestFileUrl: string,
  cookie: Cookie["cookie"]
): string => {
  const params = createPresignedUrlQueryParameter(cookie);
  return `${manifestFileUrl}?${params}`;
};

/**
 * @description manifestFileUrlの最後のpath部分を特定のファイル名に置き換えた署名付きURLを生成する
 */
export const generateSignedUrl = ({
  manifestFileUrl,
  cookie,
  fileName,
}: {
  manifestFileUrl: string;
  cookie: Cookie["cookie"];
  fileName: string;
}): string => {
  const params = createPresignedUrlQueryParameter(cookie);
  const modifiedUrl = manifestFileUrl.replace(/\/[^/]+$/, `/${fileName}`);

  return `${modifiedUrl}?${params}`;
};
